module.exports = __webpack_public_path__ + "img/fudongjia.prt.3d528634.jpg";